<template>
  <div class="">
    <sidebar-menu
      :menu="menu"
      :collapsed="collapsed"
      :hideToggle="true"
      :theme="selectedTheme"
      :show-one-child="true"
      @item-click="onItemClick">
      <template slot="header">
        <div class="row  pl-2 pt-2 headerElementStyle">
          <div class="col-9">
            <h2 class="text-white">{{sideBarTitle}}</h2>
          </div>
          <div class="col-3">
            <base-button
              size="sm"
              type="dark"
              icon="ni ni-curved-next"
              v-on:click="openModalClicked"
            >
            </base-button>
          </div>
        </div>

      </template>
    </sidebar-menu>

    <modal :show.sync="openModal">
      <template slot="header">
        <h3 class="modal-title" id="formPickerModal"><i class="ni ni-bus-front-12"></i> Lines</h3>
      </template>
      <div class="row">
        <div class="col">
          <select class="custom-select" name="" v-model="selectedLine" :disabled="lines.length>0?false:true">
            <option value="0" selected disabled>Select Line</option>
            <option v-for="(item, index) in lines" :key="index" :value="item.code">{{item.title}}</option>
          </select>
        </div>
      </div>
      <template slot="footer">
        <base-button type="secondary" v-on:click="closeModalClicked">Close</base-button>
      </template>
    </modal>
  </div>

</template>
<script>
import modal from "@/components/Modal";
  export default {
    name: "DashboardNavbar",
    components: {
      modal
    },
    props: {
      menu: Array,
      sideBarTitle: String
    },
    data() {
      return {
        activeNotifications: false,
        showMenu: false,
        searchQuery: '',
        collapsed: false,
        // selectedTheme: 'white-theme',
        selectedTheme: '',
        openModal: false,
        selectedLine: "0"
      };
    },
    computed: {
      lines: {
        get() {
          return this.$store.state.sideBarStore.lines
        }
      },
    },
    methods: {
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false);
      },
      toggleMenu() {
        this.showMenu = !this.showMenu;
      },
      onItemClick(event, item) {
        event.preventDefault();
      },
      openModalClicked: function() {
        this.openModal = true;
      },
      closeModalClicked: function() {
        this.openModal = false;
      },
    },
    watch: {
      selectedLine: function(){
        const current = this
        console.log(current.selectedLine);
        current.$store.commit("sideBarStore/setSelectedLine",current.selectedLine);
        current.$store.commit("sideBarStore/setSelectedStations",current.selectedLine);
        // current.$store.dispatch("sideBarStore/setSelectedLine",current.selectedLine);

      }
    }
  };
</script>
<style>
/* .v-sidebar-menu {
  top: 91px !important;
  left: 110px !important;
  background-color:  #2d3339 !important;
}
.v-sidebar-menu .vsm--dropdown .vsm--list {
    background-color: #2d3339 !important;
} */
.main-content {
    margin-left: 110px !important;
    /* margin-left: 460px !important; */
    /* 350 */
    /* margin-left: 0 !important; */
}
.v-sidebar-menu {
    position: relative !important;
    height: 88.9vh !important;
}
</style>
